import { autoMount } from '../../../utils/autoMount';
import { Employment } from '../../../components/organisms/employment';
import { Occupation } from '../../../components/organisms/occupation';
import { Special } from '../../../components/organisms/special';
import { Industry } from '../../../components/organisms/industry';
import { Mag } from '../../../components/organisms/mag';

autoMount({ Employment, Occupation, Special, Industry, Mag });
